import React, { Component } from "react"
import PropTypes from "prop-types"
import { WorksWithContent } from "./works_with_content"

import { compactInteger } from "humanize-plus"
import { connectionShape } from "app/lib/shared_prop_types"
import appletOrConnection from "shared/lib/use_applet_or_connection"

import "./small_applet_card.scss"

export default class Meta extends Component {
  render() {
    const { mainService, applet, userIcon } = this.props
    const humanizedInstallNumber = compactInteger(applet.installs_count, 1)
    const appletType = appletOrConnection(applet)

    return (
      <div className="meta">
        {applet.installs_count > 0 && (
          <div
            className="installs"
            aria-label={`${humanizedInstallNumber} users`}
            title={`${humanizedInstallNumber} users enabled this ${appletType}`}
          >
            <span
              className="verified"
              dangerouslySetInnerHTML={{
                __html: userIcon,
              }}
            />
            <span>{humanizedInstallNumber}</span>
          </div>
        )}
        <WorksWithContent applet={applet} mainService={mainService} />
      </div>
    )
  }
}

Meta.propTypes = {
  applet: connectionShape.isRequired,
  userIcon: PropTypes.string.isRequired,
  mainService: PropTypes.object,
}

Meta.defaultProps = {
  userIcon: "",
}
